import styled from 'styled-components';

export const StyledBusinessInformation = styled('div')`
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;

  .ant-tabs-nav {
    margin: 0 0 20px 0;
  }
  .page-footer {
    position: fixed;
  }
`;

export const StyledBusinessInformationFooter = styled('div')`
  position: fixed;
  width: -webkit-fill-available;
  bottom: 0;
  .ant-btn {
    border-radius: 3px;
  }
`;
